import React, { ReactElement } from 'react';

interface IFdrBlogDateProps {
  date: string;
}

export function FdrBlogDate({ date }: IFdrBlogDateProps): ReactElement {
  return date?.length ? (
    <time dateTime={date}>{date.split('-').reverse().join('.')}</time>
  ) : null;
}
